module.exports = __webpack_public_path__ + "assets/img/joined.f92ca7b2.svg";